export default {
  FETCH_DOSSIERS_LIST: 'FETCH_DOSSIERS_LIST',
  FETCH_DOSSIERS_LIST_SUCCESS: 'FETCH_DOSSIERS_LIST_SUCCESS',
  FETCH_DOSSIERS_COMPLETE_LIST: 'FETCH_DOSSIERS_COMPLETE_LIST',
  FETCH_EXPORT_COMPLETE_LIST: 'FETCH_EXPORT_COMPLETE_LIST'
}
